<!--//@*/*
    //    *BCS   App v0.91
    //    * Copyright (c) 2025, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
<template>
  <!-- attachment and Form -->
  <v-container id="gym_waiver_form" class="mt-13">
    <!-- attachment -->

    <v-row id="attachment" class="d-flex flex-column justify-start">
      <v-col>
        <p class="header">ATTACHMENT:</p>
      </v-col>
      <v-col>
        <p class="sub-header">
          <u
            >CITY OF RENO WELLNESS PROGRAM RELEASE WAIVER AND ASSUMPTION OF
            RISK</u
          >
        </p>
        <br />
        <p class="sub-header">
          PLEASE READ THE ENTIRE CONTENTS OF THIS DOCUMENT BEFORE SIGNING AS IT
          HAS A SIGNIFICANT EFFECT ON YOUR LEGAL RIGHTS. THIS DOCUMENT IS
          INTENDED TO UNCONDITIONALLY RELEASE THE CITY OF RENO FROM ALL
          LIABILITY ASSOCIATED WITH THE WELLNESS PROGRAM. THIS WAIVER IS NOT
          INTENDED TO ALTER OR DENY ANY RIGHTS OR OBLIGATIONS UNDER NEVADA’S
          INDUSTRIAL INSURANCE ACT.
        </p>
      </v-col>
    </v-row>

    <v-row class="d-flex flex-column justify-start">
      <v-col>
        <p>
          <strong><u>Wellness Program:</u></strong> The Wellness Program
          includes any recreational or health related program or activity made
          available or offered without fee by the City to its public officials
          and employees, including but not limited to recreational programs,
          training, and use of any exercise equipment, pools, ice rink, trails,
          mat rooms, or any other City recreational facilities, improvements and
          related equipment. Note that a rental fee or charges may apply to
          select equipment as part of the Wellness Program.
        </p>
        <br />
        <p>
          <strong><u>Unconditional Waiver/Assumption of Risk:</u></strong> In
          executing this unconditional waiver, I state that my attendance and
          participation in the Wellness Program is voluntary and is solely for
          my personal benefit and I understand that the City of Reno will
          receive no direct benefit from my participation, other than the
          intangible value of employee health and morale common to all kinds of
          recreation and social life. I fully assume all the risks of injury to
          my person and property that may be sustained in connection with the
          participation in the Wellness Program and use of any related
          facilities. I, on behalf of myself, my spouse, my parents, my
          children, my heirs, administrators, and assignees, agree that in the
          event I sustain personal injury or property damage as a result of my
          participation in the Wellness Program, the City of Reno will not be
          liable for such injury or damage.
        </p>
        <br />
        <p>
          I understand that the Wellness Program may have activities which are
          physically challenging and potentially dangerous and I assume all
          risks associated with my participation and represent that I am
          physically and emotionally capable of performing these activities. If
          I am unsure of the risks associated with an activity, I agree to
          inquire about the risks from an appropriate Wellness Program staff
          member. I further understand that my participation in the Wellness
          Program is voluntary and that the City of Reno is not responsible for
          ensuring my safety while I am participating in the Wellness Program
          and is hereby released from liability.
        </p>
        <br />
        <p>
          I understand that the City of Reno does not carry any insurance or
          liability coverage that would apply to any injury or property damage
          that I might sustain by means of such participation. Specifically, I
          understand that if I am injured I may not be covered by workers'
          compensation insurance. I agree to act in a responsible manner when
          participating in the Wellness Program and agree that my participation
          is wholly unconnected with my employment and acknowledge that I am
          pursuing a private interest on my own time. I understand that I will
          receive no compensation of any kind for participating in the Wellness
          Program. Further, I agree to follow all rules established for the
          Wellness Program and associated activities, equipment and facilities.
        </p>
      </v-col>
    </v-row>
    <div id="full" class="full-form">
      <v-form id="full_form" ref="formIn">
        <v-container>
          <v-row>
            <v-col cols="12" md="12" lg="12">
              <!-- checkbox -->
              <v-checkbox
                id="checkbox"
                v-model="formIn.agree"
                required
                :color="isChecked ? 'grey' : 'greenbtn'"
                label="By checking this box, I indicate that I HAVE READ, UNDERSTAND, AND VOLUNTARILY AGREE TO THE FOREGOING.
          Executed at Reno, Washoe County, Nevada, on this day"
              >
              </v-checkbox>
              <v-text-field
                color="greenbtn"
                id="date"
                v-model="formIn.submit_date"
                label="Date"
                required
                v-mask="'##/##/####'"
                :rules="Daterules"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" lg="12">
              <v-text-field
                color="greenbtn"
                id="email"
                v-model="formIn.email"
                name="email"
                maxlength="60"
                label="email"
                ref="email"
                :rules="emailRules"
                counter="60"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-text-field
                color="greenbtn"
                id="f_name"
                v-model="formIn.f_name"
                name="First Name"
                maxlength="60"
                label="First Name"
                ref="first_name"
                counter="60"
                :rules="reqRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <v-text-field
                color="greenbtn"
                id="l_name"
                v-model="formIn.l_name"
                name="Last Name"
                maxlength="60"
                label="Last Name"
                ref="last_name"
                counter="60"
                :rules="reqRules"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="12" lg="12">
              <v-text-field
                color="greenbtn"
                id="address"
                v-model="formIn.address"
                name="address"
                maxlength="120"
                label="Street Address"
                ref="street_address"
                counter="120"
                :rules="reqRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                color="greenbtn"
                id="city"
                v-model="formIn.city"
                name="city"
                maxlength="60"
                label="City"
                ref="city"
                counter="60"
                :rules="reqRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                color="greenbtn"
                id="state"
                v-model="formIn.state"
                name="state"
                maxlength="2"
                label="State"
                ref="state"
                :rules="reqRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                color="greenbtn"
                id="zip"
                v-model="formIn.zip"
                name="zip"
                maxlength="5"
                label="Zip"
                ref="zip"
                counter="5"
                :rules="reqRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- button row -->
          <v-row class="btn-row">
            <v-col>
              <div
                class="submit-btn mt-3 d-flex justify-space-between align-center"
              >
                <v-btn dark class="mb-2 mr-3 greenbtn black--text" @click="save"
                  >submit</v-btn
                >
                <v-btn dark class="mb-2 greenbtn black--text" @click="reset"
                  >Reset</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <div class="bottom-space"></div>
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .header p {
    font-size: 1.2em;
    font-weight: 400;
  }

  .sub-header p,
  .sub-header ol {
    font-size: 1em;
    font-weight: 300;
  }

  .full-form,
  #full_form {
    width: 100%;
  }

  .btn-row {
    width: 80%;
    margin: 0 auto;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "gym_form",
  mixins: [bus_common],
  data() {
    return {
      reqRules: [(v) => !!v || "Field is required"],
      Daterules: [(value) => this.date_is_valid(value) || "Invalid date."],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      isChecked: false,
      formIn_new: {
        submit_date: "",
        email: "",
        f_name: "",
        l_name: "",
        address: "",
        city: "Reno",
        state: "NV",
        zip: "",
        agree: false,
      },
      formIn_dev: {
        submit_date: "04/08/2025",
        email: "my@email.com",
        f_name: "River",
        l_name: "Song",
        address: "42 42nd St",
        city: "Reno",
        state: "NV",
        zip: "89503",
        agree: false,
      },
      formIn: {
        submit_date: "",
        email: "",
        f_name: "",
        l_name: "",
        address: "",
        city: "Reno",
        state: "NV",
        zip: "",
        agree: false,
      },
    };
  },
  methods: {
    save() {
      console.log("save");
      //validate
      if (this.formIn.agree == false) {
        this.swall_it(
          "Submit Status",
          "Before continuing, you must check the box at the top of the form and agree to its conditions.",
          "warning",
          null,
          null
        );
        return true;
      }
      if (this.$refs.formIn.validate() == false) {
        this.swall_it(
          "Submit Status",
          "Your form has errors. Please address the red fields.",
          "warning",
          null,
          null
        );
        return true;
      }

      this.show_loader(true);
      let form_gym = {};
      form_gym = this.formIn;
      form_gym.submit_date = this.format_date_sql(form_gym.submit_date);

      form_gym.apiname = "save";

      let self = this;
      this.$store
        .dispatch("anyapi", form_gym)
        .then((data) => {
          this.show_loader(false);

          if (data == "dupe") {
            this.swall_it(
              "Submit Status",
              "This email is already registered.",
              "warning",
              null,
              null
            );
            return true;
          } else {
            self.$refs.formIn.reset();
            setTimeout(() => {
              self.formIn.submit_date = self.format_date_us(new Date());
            }, 500);

            this.swall_it(
              "Submit Status",
              "Success. You may now close this window.",
              "success",
              null,
              null
            );
            return true;
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    reset() {
      this.$refs.formIn.reset();
    },
    message1() {
      alert("This button does nothing yet.");
    },
    message2() {
      alert("This button also does nothing yet.");
    },
    init() {
      this.formIn = this.mno(this.formIn_new);
      this.formIn.submit_date = this.format_date_us(new Date());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
